import MyTable, { MyTableHeader, MyTableBody, MyTableRow, MyTableCol } from 'components/MyTable';
import moment from 'moment';
import React, { memo, useContext, useCallback } from 'react';
import { WebHookHistoricContext } from 'v2/components/Pages/Webhook/context';
import QuickViewDefault from 'v2/components/Shared/QuickView';
import Truncate from 'v2/components/Shared/TruncateText';

import styles from './styles';

const QuickView = memo(() => {
  const classes = styles();

  const { quickView, setQuickView, webhookDetails, setWebhookDetails } = useContext(WebHookHistoricContext);

  const indexes = [
    { title: 'Code', ordering: false },
    { title: 'Resposta', ordering: false },
    { title: 'Data', ordering: false },
  ];

  const solveStatusColor = useCallback((status: string): string => {
    const statusInt = Number.parseInt(status);

    if (statusInt >= 200 && statusInt < 300) {
      return 'status-200';
    }

    return 'status-504';
  }, []);

  const handleClose = useCallback(() => {
    setQuickView(false);
    setWebhookDetails(null);
  }, [setQuickView, setWebhookDetails]);

  const historic = webhookDetails?.sends || [];
  const sent = webhookDetails?.sentData ? JSON.stringify(JSON.parse(webhookDetails.sentData), undefined, 2) : '';

  return (
    <QuickViewDefault title='Detalhes do Webhook' open={quickView} onClose={handleClose}>
      <div className={classes.historic}>
        <div className='title'>Histórico de envios</div>
        <div className='content'>
          {historic.length === 0 && <div className='not-found'>Nenhum histórico encontrado.</div>}

          {historic.length > 0 && (
            <div className='table'>
              <MyTable>
                <MyTableHeader index={indexes} />

                <MyTableBody>
                  {historic.map((item) => (
                    <MyTableRow key={moment(item.created_at).format('DD/MM/YYYY HH:mm')}>
                      <MyTableCol screenSizes={{ xs: 12, sm: 12 }} mobileOrder={1}>
                        <span className={`${classes.httpStatus} ${solveStatusColor(item.returnStatus)}`}>{item.returnStatus}</span>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 12, sm: 12 }} mobileOrder={2}>
                        <Truncate count={20} final={'...'}>
                          {item.returnData}
                        </Truncate>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 12, sm: 12 }} mobileOrder={3}>
                        {moment(item.created_at).format('DD/MM/YYYY HH:mm')}
                      </MyTableCol>
                    </MyTableRow>
                  ))}
                </MyTableBody>
              </MyTable>
            </div>
          )}
        </div>
      </div>

      <div className={classes.data}>
        <div className='title'>Dados enviados</div>
        <div className='content'>
          <pre>{sent}</pre>
        </div>
      </div>
    </QuickViewDefault>
  );
});

export default QuickView;
